import {
  Box, Flex, ModalContentProps, Text,
  useToast,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';

import { truefileServerApi } from 'api/truefilesServerApi';
import { ICreateApplicationRequest } from 'api/types/trueFileServerTypes';
import { ModalFrame } from 'components/modal/ModalFrame';
import { CreateApplicantForm } from 'pages/applicant/components/CreateApplicantForm';

const content: ModalContentProps = {
  maxW: '800px',
  minW: '720px',
  marginTop: 50,
};

export interface IChromeSecurityNoticeProps {
  isOpen: boolean;
  onClose: ()=> void;
  onNext: ()=> Promise<void>;
}
export function InitialApplicantModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean,
  onClose: ()=> void,
}): JSX.Element {
  const toast = useToast();
  const navigate = useNavigate();
  const Header = (
    <Box
      fontSize='35px' width='100%'
      paddingLeft='0px' marginBottom='0px'
    >
      <Flex direction='row' gap='10px'>
        <Text>Add an applicant:</Text>
      </Flex>
    </Box>
  );

  async function onSubmit({
    firstName, lastName, sin, middleName,
  }: ICreateApplicationRequest): Promise<void> {
    const applicantCreateQuery = await truefileServerApi.POST('/api/applications', {
      body: {
        firstName,
        lastName,
        middleName,
        sin: Number(sin),
      },
    });

    navigate(`/application/${applicantCreateQuery.data?.id}/applicant/${applicantCreateQuery.data?.applicants?.[0]!.id}`);

    toast({
      title: 'Success',
      description: 'Application Created\'',
      status: 'success',
      duration: 5000,
      position: 'top',
      isClosable: true,
    });
  }

  return (
    <ModalFrame
      hasCloseButton
      style={{ content }}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      header={Header}
    >
      <CreateApplicantForm onSubmit={onSubmit} />
    </ModalFrame>
  );
}
